import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PostalCode, PostalCodeCreate, PostalCodeFilter } from '../data/postalCode';

export function createPostalCodeService(client: AxiosInstance) {
  return createCrudService<PostalCode, PostalCodeCreate, PostalCodeFilter>(
    client,
    '/master-data/PostalCode',
    'id',
  );
}

export type PostalCodeService = CrudService<PostalCode, PostalCodeCreate, PostalCodeFilter>;
